import loadable from 'Components/AsyncModuleLoader/AsyncModuleLoader';

export default loadable({
    loader: () => import(/* webpackChunkName: "thankYouWidget" */'./ThankYouWidget'),
    loading: () => null
});
